<template>
  <transition name="fadeHubHeaderItem" mode="out-in" appear>
    <v-card
      v-if="!loading && show"
      :to="!route || disabled || redirect === true ? undefined : route"
      ripple
      :hover="!disabled"
      :disabled="(disabled || inactive)"
      @click="redirectToOutSide"
      :tk-id="trackingIdentifier"
      class="hub-header-item-text-container"
    >
      <v-icon v-if="icon">{{ icon }}</v-icon>
      <div class="hub-header-item-title">
        {{ title }}
      </div>
      <div class="hub-header-item-title short">
        {{ shortTitle }}
      </div>
    </v-card>
  </transition>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "HeaderItem",

  mixins: [checkPermissionsMixin],

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      required: true
    },

    shortTitle: {
      type: String,
      required: true
    },

    route: {
      type: String,
      required: false
    },

    permissionName: {
      type: String
    },

    inactive: {
      type: Boolean,
      default: false
    },

    redirect: {
      type: Boolean,
      default: false
    },

    trackingIdentifier: {
      type: String,
    },

    show: {
      type: Boolean,
      default: true,
    },

    icon: {
      type: String,
    }
  },

  computed: {
    disabled() {
      if (this.permissionName) {
        return !this.userHasModulePermission(this.permissionName);
      } else return false;
    },
  },

  methods:{
    redirectToOutSide(){
      if (this.redirect) {
        window.open(this.route);
      } else {
        this.$emit('click');
      }
    }
  },
}
</script>

<style scoped>
.fadeHubHeaderItem-enter {
  opacity: 0;
}

.fadeHubHeaderItem-enter-active {
  transition: opacity 1s 0.5s;
}

.hub-header-item-text-container {
  color: #231E46;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: transparent !important;
  cursor: pointer;
  display: flex;
  flex-direction: row;
}

.v-icon {
  color: #231E46;
}

.v-card {
  box-shadow: none !important;
}

.hub-header-item-title {
  font-size: 16px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.short {
  display: none;
}

.hub-item-description {
  color: #231E46;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 100% */
  text-transform: lowercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: -5px;
}

.card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.50) !important;
}

@media only screen and (max-width: 950px) {
  .hub-header-item-title.short {
    display: contents;
  }
  .hub-header-item-title {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hub/HeaderItem.vue